var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Highpriorityred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-info",
    d: "M12,20a8,8,0,1,1,8-8A8.009,8.009,0,0,1,12,20Zm0-1.2A6.8,6.8,0,1,0,5.2,12,6.791,6.791,0,0,0,12,18.8ZM12,16a.8.8,0,1,1,.8-.8A.8.8,0,0,1,12,16Zm-.009-2.791A.6.6,0,0,1,11.4,12.6V8.2a.6.6,0,1,1,1.2,0v4.4a.6.6,0,0,1-.609.609Z",
    transform: "translate(-4 -4)",
    fill: "#ff4d4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Highpriorityred);
export default __webpack_public_path__ + "static/media/icons8-high priority red.b4e141793ee16eb5e21107671f285f0f.svg";
export { ForwardRef as ReactComponent };